import React from "react";
import CustomDialogue from "../CustomDialogue";
import { ModalConfig } from "../../hooks/useModal";
import ContactUs from "../ContactUS";

type Props = {
  modalConfig: ModalConfig;
};

const ContactUsModal = ({ modalConfig }: Props) => {
  return (
    <CustomDialogue modalConfig={modalConfig}>
      <ContactUs />
    </CustomDialogue>
  );
};

export default ContactUsModal;
